import { createAction, props } from '@ngrx/store';
import { Rule } from '../../models/rule.model';
import { CreateRuleRequest } from '../../models/requests/create-rule.request';
import { UpdateRuleRequest } from '../../models/requests/update-rule.request';
import { Evaluation } from '../../models/evaluation.model';
import { UpdateEvaluationRequest } from '../../models/requests/update-evaluation-request';
import { CreateEvaluationRequest } from '../../models/requests/create-evaluation-request';
import { RuleStatistics } from '../../models/rule-statistics.model';
import { AlarmStatistics } from '../../models/alarm-statistics.model';
import { AlarmDistributionData } from '../../models/alarm-distribution.model';

export const loadRules = createAction('[Rules] Load');
export const refreshRules = createAction('[Rule] Refresh Rules');
export const loadRulesSuccess = createAction(
  '[Rules] Load Success',
  props<{ rules: Rule[] }>(),
);
export const loadRule = createAction(
  '[Rules] Load Rule',
  props<{ uniqueId: string }>(),
);
export const loadRuleSuccess = createAction(
  '[Rules] Load Rule Success',
  props<{ rule: Rule }>(),
);
export const loadRulesFailure = createAction(
  '[Rules] Load Failure',
  props<{ error: any }>(),
);

// Server-side paged loading
export const loadRulesPage = createAction(
  '[Rules] Load Page',
  props<{
    first: number;
    rows: number;
    sortField?: string | null;
    sortOrder?: number;
    filters?: Record<string, any>;
    globalFilter?: string | null;
    factory?: string | null;
    showHealthIndicator?: boolean;
    needToReload?: boolean;
  }>(),
);

export const clearPagedRules = createAction('[Rules] Clear Paged Rules');

export const loadRulesPageSuccess = createAction(
  '[Rules] Load Page Success',
  props<{ rules: Rule[]; totalRecords: number }>(),
);

export const loadRulesPageFailure = createAction(
  '[Rules] Load Page Failure',
  props<{ error: any }>(),
);

export const dropRule = createAction(
  '[Rules] Drop Rule ',
  props<{ uid: string }>(),
);

export const dropRuleSuccess = createAction(
  '[Rules] Drop Rule Success',
  props<{ uid: string }>(),
);

export const dropRuleFailure = createAction(
  '[Rules] Drop Rule Failure',
  props<{ error: any }>(),
);

export const setFilters = createAction(
  '[Rule] Set Filters',
  props<{
    criticality: string;
    alarm: string;
    period: string;
    sector: string;
    modelType: string;
    factory: string;
    subSector: string;
    state: string;
    stage: string | number;
  }>(),
);
export const resetFilters = createAction('[Rule] Reset Filters');
export const loadCriticalityOptions = createAction(
  '[Rule] Load Criticality Options',
);
export const loadCriticalityOptionssSuccess = createAction(
  '[Rule] Load Criticality Options Success',
  props<{ criticalityOptions: any[] }>(),
);
export const loadCriticalityOptionsFailure = createAction(
  '[Rule] Load Criticality Options Failure',
  props<{ error: any }>(),
);

export const createRule = createAction(
  '[Rule] Create Rule',
  props<{ createRuleRequest: CreateRuleRequest }>(),
);
export const updateRule = createAction(
  '[Rule] Update Rule',
  props<{ updateRuleRequest: UpdateRuleRequest }>(),
);

export const createRuleSuccess = createAction(
  '[Rule] Create Rule Success',
  props<{ rule: Rule }>(),
);
export const createRuleFailure = createAction(
  '[Rule] Create Rule Failure',
  props<{ error: any; message: string }>(),
);
export const updateRuleSuccess = createAction(
  '[Rule] Update Rule Success',
  props<{ rule: Rule }>(),
);
export const updateRuleFailure = createAction(
  '[Rule] Update Rule Failure',
  props<{ error: any; message: string }>(),
);

export const createRuleEvaluation = createAction(
  '[Rule] Create Rule Evaluation',
  props<{
    ruleUid: string;
    createEvaluationRequest: CreateEvaluationRequest;
  }>(),
);

export const updateRuleEvaluation = createAction(
  '[Rule] Update Rule Evaluation',
  props<{
    ruleUid: string;
    updateEvaluationRequest: UpdateEvaluationRequest;
  }>(),
);

export const updateRuleEvaluationVigie = createAction(
  '[Rule] Update Rule Evaluation Vigie',
  props<{
    ruleUid: string;
    evaluationUid: string;
    potentialCause: string;
    correctiveAction: string;
  }>(),
);

export const updateRuleEvaluationVigieFailure = createAction(
  '[Rule] Update Rule Evaluation Vigie Failure',
  props<{ error: any }>(),
);

export const updateRuleEvaluationSuccess = createAction(
  '[Rule] Update Rule Evaluation Success',
  props<{ ruleUid: string; evaluation: Evaluation }>(),
);

export const updateRuleEvaluationFailure = createAction(
  '[Rule] Update Rule Evaluation Failure',
  props<{ error: any }>(),
);

// Rule Statistics Actions
export const loadRuleStatistics = createAction('[Rules] Load Statistics');

export const loadRuleStatisticsSuccess = createAction(
  '[Rules] Load Statistics Success',
  props<{ statistics: RuleStatistics }>(),
);

export const loadRuleStatisticsFailure = createAction(
  '[Rules] Load Statistics Failure',
  props<{ error: any }>(),
);

// Alarm Statistics Actions
export const loadAlarmStatistics = createAction(
  '[Rules] Load Alarm Statistics',
);

export const loadAlarmStatisticsSuccess = createAction(
  '[Rules] Load Alarm Statistics Success',
  props<{ alarmStatistics: AlarmStatistics }>(),
);

export const loadAlarmStatisticsFailure = createAction(
  '[Rules] Load Alarm Statistics Failure',
  props<{ error: any }>(),
);
